import { render, staticRenderFns } from "./BallotOptin.vue?vue&type=template&id=3ab83d51&"
import script from "./BallotOptin.vue?vue&type=script&lang=js&"
export * from "./BallotOptin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports